interface CustomMatIcon {
  name: string;
  url: string;
}

const root = '/assets/icons/';

export const customMatIcons: CustomMatIcon[] = [
  {
    name: 'telegram',
    url: root + 'telegram.svg'
  },
  {
    name: 'whatsapp',
    url: root + 'whatsapp.svg'
  },
  {
    name: 'telegram-simple',
    url: root + 'telegram-simple.svg'
  },
  {
    name: 'whatsapp-simple',
    url: root + 'whatsapp-simple.svg'
  },
  {
    name: 'edit',
    url: root + 'edit.svg'
  }
];
